import {customElement, property} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import { imageStyles } from './image.styles'
import { allStyles } from './styles'
import { allFacets } from './templates'

@customElement('sbk-image')
export class SbkImage extends LitElement {

  @property({ type: Number })
  facet?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 = 1;

  @property({attribute: 'crop-mobile', type: Boolean})
  cropMobile = false;

  @property()
  variant?: 'default' | 'alternative' = 'default';

  static get styles() {
    return [imageStyles, allStyles];
  }

  render() {
    return html`
      <div class="image-container image__facet-${this.facet} image__facet-${this.facet}--${this.variant}${this.cropMobile ? ` image__facet-${this.facet}--crop-mobile` : ''}">
        <slot></slot>
        ${this._renderShapes()}
      </div>
    `;
  }

  _renderShapes() {
    const facetsWithVariant = [1, 2, 4, 5, 6];
    const facetsWithoutVariant = [3, 7, 8, 9, 10];

    if (facetsWithVariant.includes(this.facet!)) {
      return allFacets.getFacet(this.facet!, this.variant === 'default');
    } else if (facetsWithoutVariant.includes(this.facet!)) {
      return allFacets.getFacet(this.facet!);
    }
  }
}